export default {
  // 海知友
  HZYTarget: '7a8a25a546646355c07a1b9c5bfbd9fb',
  HZYTarget_test: '7a8a25a546646355c07a1b9c5bfbd9fb',

  // 积分
  JiFenTarget: '4542349d17217cac9743761e45500184',
  JiFenTarget_test: '4542349d17217cacc8940de9925b82d15affba05d6537bab',
  // 直播
  LiveTarget: 'abb43fe5ecadc8ae855ea95d171a6918',
  LiveTarget_test: 'abb43fe5ecadc8ae855ea95d171a6918',

  // 服务进度
  ssUrlTarget: '0d3e477c75f5da4c7a8e2c00d794cd75',
  ssUrlTarget_test: '0d3e477c75f5da4ce43ed815e451e2d2',

  // 查看卡号
  ccUrlTarget: '0d3e477c75f5da4c7a8e2c00d794cd75',
  ccUrlTarget_test: '0d3e477c75f5da4ce43ed815e451e2d2',
}
